class SectionAnchors extends HTMLElement {
    constructor() {
        super();
        this.anchors = this.querySelectorAll('.js-anchor');

        this.anchors.forEach((anchor) => {
            anchor.addEventListener('click', this.handleSmoothScroll.bind(this));
        });
    }

    handleSmoothScroll(event) {
        event.preventDefault();
        const target = event.target;
        document.querySelector(target.getAttribute('href')).scrollIntoView({
            behavior: 'smooth',
        });
    }
}

customElements.define('section-anchors', SectionAnchors);
